import { deepMerge } from '@/scripts/common/utilities/deepMerge';

export const deepMergePlugin = (store) => {
    store.deepMerge = deepMerge;
};